import React, { useContext } from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import {ReactComponent as MessageSquareIcon} from "../../../../../assets/images/icons/message-square.svg";
import { ApiContext } from '../../../../../services/api/api-config';
import { getNotifier } from '../../../../../services/notifier';
import NotificationCount from './components/NotificationCount/NotificationCount';
import {useSelector} from "react-redux";
import './NotificationsBar.scss';
import NotificationsListRightBar from './components/NotificationsListRightBar/NotificationsListRightBar';
const customProp = 'notifications';

const NotificationsBar = () => {
    const api = useContext(ApiContext);
    const [notifications, setNotifications] = useState([]);
    const [showNotificationsModal, setShowNotificationsModal] = useState();

    useEffect(() => {
        api.notifications.get_header_notifications({params: {}, customProp}).then((res) => {
            setNotifications(res);
        }).catch((err) => getNotifier().error(err.message||err.detail));
    }, [api]);

    let {totalNotReadedItems} = useSelector(({api})=>api[customProp+'Meta'])||{totalNotReadedItems:0};

    const reloadNitifications = async () => {
        const _notifications = await api.notifications.get_header_notifications({params: {}, customProp})
        setNotifications(_notifications);
    }

    return (
        <div className='NotificationsBar'>
            <MessageSquareIcon />
            <NotificationCount 
                notificationsTotal={totalNotReadedItems} 
                setShowNotificationsModal={() => setShowNotificationsModal(true)}
            />

            {showNotificationsModal &&
                <NotificationsListRightBar 
                    notifications={notifications} 
                    onHideBar={() => setShowNotificationsModal(false)}
                    reloadNitifications={reloadNitifications}
                />}
        </div>
    )
}


export default NotificationsBar;